import { FC, RefCallback, useEffect } from 'react';
import { useMaskito } from '@maskito/react';
import { MaskitoOptions } from '@maskito/core';
import { IContactMethod, IContactMethodType } from '../caremap/ICareMap';
import { TextField } from '../components/TextField';

export interface IPhoneContactMethod extends Omit<IContactMethod, 'type'> {
    type: Exclude<IContactMethodType, 'email'>
};

type IPhoneFieldProps = {
    method: IPhoneContactMethod;
    //autoFocus?: boolean;
    showOptional?: boolean;
    isValid?: (valid: boolean) => void;
    methodChanged: (method: IContactMethod) => void;
    required?: boolean;
};

export const PhoneField: FC<IPhoneFieldProps> = ({ method, methodChanged, showOptional, isValid, required = false }) => {
    const mobilePhoneMask: MaskitoOptions = { mask: [/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] };
    const workPhoneMask: MaskitoOptions = { mask: [/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, ' ', 'x', /\d/, /\d/, /\d/, /\d/] };

    const mobilePhoneRef = useMaskito({ options: mobilePhoneMask });
    const workPhoneRef = useMaskito({ options: workPhoneMask });

    const validate = (value: string) => {
        if (isValid) {
            isValid(value.length >= 12);
        }
    };

    // validate on load
    useEffect(() => {
        validate(method?.value || '');
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    let fieldLabel = '';
    let placeholder = '';
    let inputRef: RefCallback<HTMLElement> | undefined;
    switch (method?.type) {
        case 'mobile-phone':
            fieldLabel = `Cell Phone${showOptional ? ' (optional)': ''}`;
            placeholder = '999-999-9999';
            inputRef = mobilePhoneRef;
            break;
        case 'work-phone':
            fieldLabel = `Work Phone${showOptional ? ' (optional)': ''}`;
            placeholder = '999-999-9999 x999';
            inputRef = workPhoneRef;
            break;
    };

    const valueChanged = (value: string) => {
        methodChanged({ ...method, value });
        validate(value);
    };

    return (
        <TextField
            inputRef={inputRef as any}
            //autoFocus={autoFocus}
            name={`${method.type}-field`}
            label={fieldLabel}
            placeholder={placeholder}
            value={method?.value}
            required={required}
            autocapitalize="none"
            onInput={valueChanged}
        />
    );
};
